module.exports = __webpack_public_path__ + "static/media/image-card-4.fc5a3098.png";